import type { FieldNamesMarkedBoolean } from "react-hook-form"

import type { Classification, ClassificationCreateInput, ClassificationUpdateInput } from "@/graphql/codegen/graphql"
import type { ProductClassificationFormValues } from "@/screens/ManageProducts/components/ProductClasses/forms/classSchema"
import { normalizeToUpperCase } from "@/utils/utils"

const preprocessCommonFields = (input: ProductClassificationFormValues) => ({
  name: normalizeToUpperCase(input.name),
  productManagerId: input.productManager?.id,
})

export const preprocessCreateInput = (input: ProductClassificationFormValues): ClassificationCreateInput => {
  return {
    categoryId: input.category?.id,
    ...preprocessCommonFields(input),
  }
}

export const preprocessUpdateInput = (
  input: ProductClassificationFormValues,
  classificationId: string,
  dirtyFields: Partial<Readonly<FieldNamesMarkedBoolean<ProductClassificationFormValues>>>
): ClassificationUpdateInput => {
  const keys = Object.keys(dirtyFields) as (keyof ProductClassificationFormValues)[]
  return {
    classificationId,
    ...(keys.includes("name") && {
      name: normalizeToUpperCase(input.name),
    }),
    ...(keys.includes("productManager") && {
      productManagerId: input.productManager?.id,
    }),
  }
}

export const prepareFormData = (data: Classification): ProductClassificationFormValues => {
  return {
    category: {
      label: data.categoryDetail?.name ?? "",
      id: data.categoryDetail?.categoryId ?? "",
    },
    name: data.name,
    productManager: {
      label: data.productManager ? `${data.productManager.firstName} ${data.productManager.lastName}` : "",
      id: (data.productManager as any)?.userId ?? "",
    },
  }
}
